import { getLocalizedPath } from "./getLocalizedPath";

/**
 * Returns the app root the user should be redirected to based on their app access.
 * - RMS if user has RMS (or both)
 * - FMS if user has only FMS
 * - Defaults to RMS if no apps
 *
 * The router resolves the app root to the first page the user actually has
 * access to, so we no longer hard-code a landing page (e.g. /dashboard) here —
 * the dashboard may not be available depending on privileges.
 */
export const getDashboardRedirectPath = (user) => {
  const u = user?.user ?? user;
  const apps = u?.apps || [];
  const hasRms = apps.some((app) => app.slug === "rms");
  const hasFms = apps.some((app) => app.slug === "fms");
  const path = hasRms ? "/rms" : hasFms ? "/fms" : "/rms";
  return getLocalizedPath(path);
};
